import React from 'react';
import {CommonEdit} from '../Common';
import {getInputs} from './Common';

export const DocumentTypeEdit = props => <CommonEdit {...props} fields={getInputs()} />;
